import React, { useState, useEffect } from 'react'
import { Panel, Grid, Row, Col, Placeholder } from 'rsuite'

export default function GarbageBGView({ schema }) {
  const { Paragraph } = Placeholder

  const communityBasicInfo = schema.communityBasicInfo && schema.communityBasicInfo
  const situationOfWaste = schema.communityBasicInfo && schema.situationOfWaste

  const [garbageSortMethod, setGarbageSortMethod] = useState([])
  const [garbageBenefitMethod, setGarbageBenefitMethod] = useState([])

  useEffect(() => {
    if (situationOfWaste) {
      let garbageSortMethodValue = [
        ...situationOfWaste.garbageManagement.garbageSortBenefit.garbageSortMethod.value,
      ]

      let garbageBenefitMethodValue = [
        ...situationOfWaste.garbageManagement.garbageSortBenefit.garbageBenefitMethod.value,
      ]

      setGarbageSortMethod(garbageSortMethodValue)
      setGarbageBenefitMethod(garbageBenefitMethodValue)
    }
  }, [schema])

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row>
            {communityBasicInfo && (
              <Col xs={24} sm={24} md={24} lg={24}>
                <p style={{ marginBottom: 10, marginTop: 10 }}>
                  <b>{communityBasicInfo.label}</b>
                </p>
                {communityBasicInfo.value ? (
                  <div
                    style={{ marginTop: 10 }}
                    dangerouslySetInnerHTML={{
                      __html: '&nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;' + communityBasicInfo.value,
                    }}
                  />
                ) : (
                  <Paragraph type="media" style={{ marginLeft: 30 }} />
                )}
              </Col>
            )}

            {situationOfWaste && (
              <>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <p style={{ marginTop: 10, marginBottom: 10 }}>
                    <b>{situationOfWaste.label}</b>
                  </p>
                </Col>

                <br />
                <Col xs={24} sm={24} md={24} lg={24}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        '&nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;' +
                        situationOfWaste.community.label +
                        ' ' +
                        (situationOfWaste.community.value
                          ? situationOfWaste.community.value
                          : ' ............................. ') +
                        ' ' +
                        situationOfWaste.household.label +
                        ' ' +
                        (situationOfWaste.household.value
                          ? situationOfWaste.household.value +
                            ' ' +
                            situationOfWaste.household.postLabel
                          : ' ............................. ') +
                        ' ' +
                        situationOfWaste.population.label +
                        ' ' +
                        (situationOfWaste.population.value
                          ? situationOfWaste.population.value +
                            ' ' +
                            situationOfWaste.population.postLabel
                          : ' ............................. ') +
                        ' ' +
                        situationOfWaste.garbageAverage.label +
                        ' ' +
                        (situationOfWaste.garbageAverage.value
                          ? situationOfWaste.garbageAverage.value +
                            ' ' +
                            situationOfWaste.garbageAverage.postLabel
                          : ' ............................. ') +
                        ' ' +
                        situationOfWaste.garbageType.label +
                        ' ' +
                        (situationOfWaste.garbageType.value
                          ? situationOfWaste.garbageType.value
                          : ' ............................. '),
                    }}
                  />
                </Col>

                <br />
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                  <p style={{ marginLeft: 20 }}>
                    {situationOfWaste.problemState.label +
                      ' ' +
                      (situationOfWaste.problemState.value
                        ? situationOfWaste.problemState.value
                        : ' ............................. ')}
                  </p>
                  <p style={{ marginLeft: 20 }}>
                    {situationOfWaste.problemCase.label +
                      ' ' +
                      (situationOfWaste.problemCase.value
                        ? situationOfWaste.problemCase.value
                        : ' ............................. ')}
                  </p>
                  <p style={{ marginLeft: 20 }}>
                    {situationOfWaste.impactCommunity.label +
                      ' ' +
                      (situationOfWaste.impactCommunity.value
                        ? situationOfWaste.impactCommunity.value
                        : ' ............................. ')}
                  </p>
                </Col>
              </>
            )}

            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <p style={{ marginLeft: 20, marginBottom: 5 }}>
                {situationOfWaste.garbageManagement.label}
              </p>
              <Panel>
                <Row style={{ marginBottom: 10 }}>
                  <Col xs={24} sm={24} md={24} lg={7} style={{ marginLeft: 20, marginBottom: 10 }}>
                    {situationOfWaste.garbageManagement.allHouseholds.label}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <p>
                      {situationOfWaste.garbageManagement.allHouseholds.preLabel}{' '}
                      {situationOfWaste.garbageManagement.allHouseholds.value
                        ? situationOfWaste.garbageManagement.allHouseholds.value
                        : '.........'}{' '}
                      {situationOfWaste.garbageManagement.allHouseholds.postLabel}
                    </p>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <p>
                      {situationOfWaste.garbageManagement.allHouseholdsPercentage.preLabel}{' '}
                      {situationOfWaste.garbageManagement.allHouseholdsPercentage.value
                        ? situationOfWaste.garbageManagement.allHouseholdsPercentage.value
                        : '.........'}
                    </p>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 10 }}>
                  <Col xs={24} sm={24} md={24} lg={7} style={{ marginLeft: 20, marginBottom: 10 }}>
                    {situationOfWaste.garbageManagement.garbageSortBefor.label}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <p>
                      {situationOfWaste.garbageManagement.garbageSortBefor.preLabel}{' '}
                      {situationOfWaste.garbageManagement.garbageSortBefor.value
                        ? situationOfWaste.garbageManagement.garbageSortBefor.value
                        : '.........'}{' '}
                      {situationOfWaste.garbageManagement.garbageSortBefor.postLabel}
                    </p>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <p>
                      {situationOfWaste.garbageManagement.garbageSortBeforPercentage.preLabel}{' '}
                      {situationOfWaste.garbageManagement.garbageSortBeforPercentage.value
                        ? situationOfWaste.garbageManagement.garbageSortBeforPercentage.value
                        : '.........'}
                    </p>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 10 }}>
                  <Col xs={24} sm={24} md={24} lg={7} style={{ marginLeft: 20, marginBottom: 10 }}>
                    {situationOfWaste.garbageManagement.garbageBenefit.label}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <p>
                      {situationOfWaste.garbageManagement.garbageBenefit.preLabel}{' '}
                      {situationOfWaste.garbageManagement.garbageBenefit.value
                        ? situationOfWaste.garbageManagement.garbageBenefit.value
                        : '.........'}{' '}
                      {situationOfWaste.garbageManagement.garbageBenefit.postLabel}
                    </p>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <p>
                      {situationOfWaste.garbageManagement.garbageBenefitPercentage.preLabel}{' '}
                      {situationOfWaste.garbageManagement.garbageBenefitPercentage.value
                        ? situationOfWaste.garbageManagement.garbageBenefitPercentage.value
                        : '.........'}
                    </p>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 10 }}>
                  <Col xs={24} sm={24} md={24} lg={7} style={{ marginLeft: 20, marginBottom: 10 }}>
                    {situationOfWaste.garbageManagement.garbageNoSort.label}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <p>
                      {situationOfWaste.garbageManagement.garbageNoSort.preLabel}{' '}
                      {situationOfWaste.garbageManagement.garbageNoSort.value
                        ? situationOfWaste.garbageManagement.garbageNoSort.value
                        : '.........'}{' '}
                      {situationOfWaste.garbageManagement.garbageNoSort.postLabel}
                    </p>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <p>
                      {situationOfWaste.garbageManagement.garbageNoSortPercentage.preLabel}{' '}
                      {situationOfWaste.garbageManagement.garbageNoSortPercentage.value
                        ? situationOfWaste.garbageManagement.garbageNoSortPercentage.value
                        : '.........'}
                    </p>
                  </Col>
                </Row>

                <Col xs={24} sm={24} md={24} lg={24} style={{ marginLeft: 20 }}>
                  <p style={{ marginLeft: 0, marginTop: 10 }}>
                    <b>{situationOfWaste.garbageManagement.garbageSortBenefit.label}</b>
                  </p>
                </Col>

                <Col xs={24} sm={24} md={24} lg={24} style={{ marginLeft: 20 }}>
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24} style={{ marginLeft: 20 }}>
                      <p style={{ marginLeft: 25, marginBottom: 10 }}>
                        <li>
                          {
                            situationOfWaste.garbageManagement.garbageSortBenefit.garbageSortMethod
                              .label
                          }
                        </li>
                      </p>
                    </Col>
                    <Col>
                      <Row style={{ marginBottom: 10, marginLeft: 40 }}>
                        {garbageSortMethod.map((item, index) => {
                          return (
                            <>
                              <Col xs={1} sm={1} md={1} lg={1} style={{ textAlign: 'right' }}>
                                <p>{index + 1}) </p>
                              </Col>
                              <Col xs={23} sm={23} md={23} lg={23}>
                                {item}
                              </Col>
                            </>
                          )
                        })}

                        {garbageSortMethod.length == 0 && (
                          <Col xs={24} sm={24} md={24} lg={24}>
                            <Paragraph />
                          </Col>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col xs={24} sm={24} md={24} lg={24} style={{ marginLeft: 20 }}>
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24} style={{ marginLeft: 20 }}>
                      <p style={{ marginLeft: 25, marginBottom: 10 }}>
                        <li>
                          {
                            situationOfWaste.garbageManagement.garbageSortBenefit
                              .garbageBenefitMethod.label
                          }
                        </li>
                      </p>
                    </Col>

                    <Col>
                      <Row style={{ marginBottom: 10, marginLeft: 40 }}>
                        {garbageBenefitMethod.map((item, index) => {
                          return (
                            <>
                              <Col xs={1} sm={1} md={1} lg={1} style={{ textAlign: 'right' }}>
                                <p>{index + 1}) </p>
                              </Col>
                              <Col xs={23} sm={23} md={23} lg={23}>
                                {item}
                              </Col>
                            </>
                          )
                        })}

                        {garbageBenefitMethod.length == 0 && (
                          <Col xs={24} sm={24} md={24} lg={24}>
                            <Paragraph />
                          </Col>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col xs={24} sm={24} md={24} lg={24} style={{ marginLeft: 20 }}>
                  <p style={{ marginLeft: 0, marginTop: 10 }}>
                    <b>{situationOfWaste.garbageManagement.noSortGarbageManagement.label}</b>
                  </p>
                  {situationOfWaste.garbageManagement.noSortGarbageManagement.value ? (
                    <p style={{ marginBottom: 10 }}>
                      &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;
                      {situationOfWaste.garbageManagement.noSortGarbageManagement.value}
                    </p>
                  ) : (
                    <>
                      <Paragraph style={{ marginLeft: 40, marginBottom: 10 }} rows={1} />
                      <Paragraph />
                    </>
                  )}
                </Col>
              </Panel>
            </Col>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginLeft: 20 }}>
                <p style={{ marginLeft: 0, marginTop: 10 }}>
                  <b>{schema.previousGarbageManagement.label}</b>
                </p>
                {schema.previousGarbageManagement.value ? (
                  <p style={{ marginBottom: 10 }}>
                    &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;
                    {schema.previousGarbageManagement.value}
                  </p>
                ) : (
                  <>
                    <Paragraph style={{ marginLeft: 40, marginBottom: 20 }} rows={1} />
                    <Paragraph />
                  </>
                )}
              </Col>
            </Row>
          </Row>
        </Grid>
      </Panel>
    </>
  )
}
